module.exports = __webpack_public_path__ + "img/portrait-092.ab3c4a47.jpg";